// Libraries
import React from 'react'

// Components
import SocialButton from './SocialButton'
import {GoogleLogo} from '../SignupLogos'

// Types
import {Auth0Connection} from 'js/types'

interface Props {
  handleSocialClick: (connection: Auth0Connection) => void
}

const GoogleSocialButton = ({handleSocialClick}: Props): JSX.Element => (
  <SocialButton
    handleClick={() => handleSocialClick(Auth0Connection.Google)}
    className="sign-up--google"
    buttonText="Google"
  >
    <GoogleLogo className="social-button--icon" />
  </SocialButton>
)

export default GoogleSocialButton
